import pslDropdown from './dropdown.js';
import pslCarousel from './carousel.js';
import pslModal from './modal.js';
import pslOffcanvas from './offcanvas.js';
import pslToast from './toast.js';


// Somehow when compiling the original bootstrap namespace is being overwritten which is stopping native bootstrap function on the site from working correctly. We preseve them here.
const bootstrapDescriptor = Object.getOwnPropertyDescriptor(window, 'bootstrap');
if (!bootstrapDescriptor || bootstrapDescriptor.configurable) {
	// console.debug('[Bootstrap Bundle] Preserving original bootstrap namespace.');
	let originalBootstrap = window.bootstrap ? { ...window.bootstrap } : {};
	Object.defineProperty(window, 'bootstrap', {
		set(value) {},
		get() {
			return originalBootstrap;
		},
	});
} else {
	// console.debug('window.bootstrap is non-configurable. Skipping redefinition.');
}

const pslBootstrap = {
	pslDropdown,
	pslCarousel,
	pslModal,
	pslOffcanvas,
	pslToast
};

// Attach pslBootstrap to the global window object.
if ( typeof window !== 'undefined' ) {
	window.pslBootstrap = pslBootstrap;
}

export default pslBootstrap;
